module.exports = __webpack_public_path__ + "img/74.da27a07a.png";